import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'

Vue.use(VueResource)
Vue.use(VueRouter)

const router = new VueRouter({
    history: false
})

import Indexhome from './modules/home/home.vue'
import Conteudo from './modules/conteudo/conteudo.vue'
import Acessibilidade from './modules/conteudo/acessiibilidade.vue'
import Mapa from './modules/conteudo/mapa.vue'

router.map({
	'/': {
		    name: 'index',
		    component: Conteudo,
		},
	'/:tipo/:valor': {
		    name: 'conteudo',
		    component: Conteudo,
		},
	'/acessibilidade': {
		name: 'acessibilidade',
		component: Acessibilidade
	},
	'/mapa': {
		name: 'mapa',
		component: Mapa
	}
});


router.start(App, '#app')

/*new Vue({
  el: 'body',
  components: { App }
})*/



// WEBPACK FOOTER //
// ./src/main.js